<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <v-card-text>
          <v-container>
            <h2>IABF Corps Pieces</h2>
            <v-btn
              color="primary"
              :loading="creating"
              @click="onNewPiece"
            >
              + New Piece
            </v-btn>
            <hr />
            <v-simple-table>
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Roles</th>
                  <th>Dancers</th>
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="piece in pieces" :key="piece.id">
                  <td>{{ piece.title }}</td>
                  <td>{{ piece.roles ? piece.roles.length : 0 }}</td>
                  <td>{{ piece.allDancerIds ? piece.allDancerIds.length : 0 }}</td>
                  <td>
                    <v-btn
                      icon
                      :to="'/iabf/admin/corps-pieces/edit/' + piece.id"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <tr v-if="pieces.length === 0">
                  <td colspan="4" class="text-center">No corps pieces yet.</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-container>
        </v-card-text>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style scoped>
h2 {
  font-family: Quattrocento, Georgia, serif;
  font-weight: 400;
  font-size: 36px;
  letter-spacing: -.02em;
  margin-bottom: 16px;
}
hr {
  margin: 12px 0;
}
</style>

<script>
export default {
  data () {
    return {
      creating: false
    }
  },
  computed: {
    pieces () {
      return this.$store.getters.loadedIABFCorpsPieces
    }
  },
  created () {
    this.$store.dispatch('loadIABFCorpsPieces')
  },
  methods: {
    async onNewPiece () {
      this.creating = true
      try {
        const newId = await this.$store.dispatch('createIABFCorpsPiece', {
          title: 'New Piece',
          description: '',
          stageFormationUrl: '',
          roles: [],
          allDancerIds: []
        })
        this.$router.push('/iabf/admin/corps-pieces/edit/' + newId)
      } finally {
        this.creating = false
      }
    }
  }
}
</script>
